import { Button, Stack, AppBar, Box, Toolbar } from '@mui/material';
import Link from 'next/link';
import SvgIconWrapper, { IconSvg, IconType } from '../Icon';
import DrawerMenu from './DrawerMenu';
import { appDetails } from '@/utils/configs';
import { HeaderEvents } from '@/misc/event-enums';
import { ROUTES } from '@/utils/constants';
import Logo from '@/components/widgets/Logo';
import BodyMedium from '@/components/typography/BodyMedium';
import SignInUpButton from '@/components/layout/SignInUpButton';
type NavbarProps = {
  isLoggedIn: boolean;
};
const Navbar = async ({
  isLoggedIn
}: NavbarProps) => {
  const navItems = [{
    title: 'طرح‌ها',
    url: ROUTES.crowdfundingPlan.href,
    eventKey: HeaderEvents.Plans
  }, ...(isLoggedIn ? [{
    title: ROUTES.userCrowdfundingPlan.name,
    url: ROUTES.userCrowdfundingPlan.href,
    eventKey: HeaderEvents.MyPlans
  }] : []), {
    title: 'جذب سرمایه',
    url: ROUTES.fundraiser.root.href,
    eventKey: HeaderEvents.InvestRequest
  }, {
    title: ROUTES.about.name,
    url: ROUTES.about.href,
    eventKey: HeaderEvents.About
  }];
  const userMenuItems = [{
    title: 'dashboard',
    url: '/dashboard/user-information',
    icon: 'ProfileV2' as IconType,
    eventKey: HeaderEvents.About
  }];
  return <AppBar position='fixed' sx={{
    height: 'auto',
    boxShadow: 'unset'
  }} data-sentry-element="AppBar" data-sentry-component="Navbar" data-sentry-source-file="Navbar.tsx">
      <Toolbar data-sentry-element="Toolbar" data-sentry-source-file="Navbar.tsx">
        <Stack sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        py: {
          xs: 'var(--spacing_xs)',
          md: 'var(--spacing_m)'
        },
        bgcolor: 'background.bg'
      }} data-sentry-element="Stack" data-sentry-source-file="Navbar.tsx">
          <Stack sx={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 'var(--spacing_m)',
          width: {
            xs: !isLoggedIn ? 'unset' : '100%',
            md: 'unset'
          }
        }} data-sentry-element="Stack" data-sentry-source-file="Navbar.tsx">
            <Box sx={{
            display: {
              md: 'none'
            }
          }} data-sentry-element="Box" data-sentry-source-file="Navbar.tsx">
              <DrawerMenu data-sentry-element="DrawerMenu" data-sentry-source-file="Navbar.tsx" />
            </Box>

            <Logo data-sentry-element="Logo" data-sentry-source-file="Navbar.tsx" />

            <Box sx={{
            display: {
              xs: 'none',
              md: 'flex'
            },
            flexDirection: 'row',
            alignItems: 'center',
            gap: 'var(--spacing_m)'
          }} data-sentry-element="Box" data-sentry-source-file="Navbar.tsx">
              {navItems.map((navItem, idx) => {
              return <Box component={Link} href={navItem.url} key={'nav_item_d' + idx} sx={{
                typography: 'bodyMedium__Wallfund',
                color: 'text.text',
                py: 'var(--spacing_xxs)',
                px: 'var(--spacing_xs)',
                borderRadius: 'var(--corner_radius_m)',
                ':hover': {
                  backgroundColor: 'background.hover'
                }
              }} data-gtm-button-id={navItem.eventKey}>
                    {navItem.title}
                  </Box>;
            })}
            </Box>
          </Stack>

          <Stack sx={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 'var(--spacing_m)'
        }} data-sentry-element="Stack" data-sentry-source-file="Navbar.tsx">
            {isLoggedIn && <Stack sx={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 'var(--spacing_m)',
            display: {
              xs: 'none',
              md: 'flex'
            }
          }}>
                {userMenuItems.map(({
              icon,
              url,
              eventKey
            }, idx) => {
              return <Box component={Link} href={url} key={'user_item_m' + idx} sx={{
                maxHeight: 40,
                borderRadius: 'var(--corner_radius_m)',
                ':hover': {
                  backgroundColor: 'background.hover'
                }
              }} data-gtm-button-id={eventKey}>
                      <IconSvg component={icon} width={40} height={40} />
                    </Box>;
            })}
              </Stack>}

            {!isLoggedIn && <SignInUpButton />}
            <Button LinkComponent={Link} href={`tel:${appDetails.supportPhone}`} startIcon={<SvgIconWrapper component='Headphone' />} aria-label='تماس با پشتیبانی' sx={{
            display: {
              xs: 'none',
              sm: 'inline-flex'
            }
          }} data-sentry-element="Button" data-sentry-source-file="Navbar.tsx">
              <BodyMedium sx={{
              display: {
                xs: 'none',
                md: 'inline-flex'
              }
            }} data-sentry-element="BodyMedium" data-sentry-source-file="Navbar.tsx">
                {appDetails.supportPhoneLabel}
              </BodyMedium>
            </Button>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>;
};
export default Navbar;